<div class="pd-lr-30" fxLayout="column" fxLayoutGap="20px">
  <div class="black-line"></div>

  <div class="w100" fxLayout="row" fxLayoutAlign="space-between start">
    <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon svgIcon="arrow-below"></mat-icon>
        <h3 class="rm-margin">{{ "BUYING_PRICE" | translate }}</h3>
      </div>
      <span>{{ buyPrice | euro}}</span>
    </div>

    <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon svgIcon="arrow-below"></mat-icon>
        <h3 class="rm-margin">{{ "SALES_PRICE" | translate }}</h3>
      </div>
      <span>{{ sellPrice | euro}}</span>
    </div>
  </div>
</div>
